import { BookOpen, Server, Database, HardDrive, RefreshCw, Shield } from 'lucide-react'
import { PageHeader } from '../../components/PageHeader'
import { useI18n } from '../../i18n'

export function DeployGuidePage() {
  const { t } = useI18n()

  const sections = [
    {
      icon: Server,
      title: '系统要求 / Requirements',
      items: [
        'Linux x86_64 (Ubuntu 22.04+ / Debian 12+ / CentOS 9+)',
        'Docker 24+ & Docker Compose v2',
        '2 CPU / 2GB RAM / 20GB SSD (minimum)',
        '开放端口: 25, 143, 587, 993 (邮件), 80/443 (Web)',
      ],
    },
    {
      icon: Database,
      title: '首次部署 / First Deploy',
      items: [
        '1. git clone your-repo && cd swiss-mail',
        '2. cp .env.example .env && 编辑 .env 配置',
        '3. docker compose up -d',
        '4. 访问 http://your-ip:3005 登录管理后台',
        '5. 添加域名 → 配置 DNS → 验证 → 创建邮箱',
      ],
    },
    {
      icon: HardDrive,
      title: '数据备份 / Backup',
      items: [
        'PostgreSQL: docker compose exec postgres pg_dump -U swiss_mail swiss_mail > backup.sql',
        '邮件数据: docker run --rm -v swiss-mail_mail_data:/data -v $(pwd):/backup alpine tar czf /backup/mail.tar.gz /data',
        '配置文件: .env + infra/ 目录已在 git 中',
        '建议每日自动备份 + 异地存储',
      ],
    },
    {
      icon: RefreshCw,
      title: '迁移到新服务器 / Migration',
      items: [
        '1. 在新服务器安装 Docker + Docker Compose',
        '2. git clone 代码仓库',
        '3. 复制 .env 文件到新服务器',
        '4. 恢复数据库: cat backup.sql | docker compose exec -T postgres psql -U swiss_mail swiss_mail',
        '5. 恢复邮件: docker run --rm -v swiss-mail_mail_data:/data -v $(pwd):/backup alpine tar xzf /backup/mail.tar.gz -C /',
        '6. docker compose up -d',
        '7. 更新 DNS 记录指向新服务器 IP',
      ],
    },
    {
      icon: Shield,
      title: '安全建议 / Security',
      items: [
        '修改 .env 中的 JWT_SECRET 和 ENCRYPTION_KEY 为随机值',
        '修改 POSTGRES_PASSWORD',
        '使用 Nginx/Caddy 反向代理并启用 HTTPS',
        '配置防火墙仅开放必要端口',
        '定期更新 Docker 镜像: docker compose pull && docker compose up -d',
      ],
    },
  ]

  return <>
    <PageHeader title="admin.deployGuide" />

    <div className="space-y-5">
      {sections.map(({ icon: Icon, title, items }) => (
        <div key={title} className="panel p-5">
          <div className="flex items-center gap-3 mb-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <Icon size={18} />
            </span>
            <h3 className="font-semibold">{title}</h3>
          </div>
          <ul className="space-y-2 pl-12">
            {items.map((item, i) => (
              <li key={i} className="text-sm text-muted-foreground leading-relaxed font-mono">{item}</li>
            ))}
          </ul>
        </div>
      ))}

      <div className="panel p-5 border-amber-200 bg-amber-50/30">
        <div className="flex items-center gap-3 mb-2">
          <BookOpen size={18} className="text-amber-600" />
          <h3 className="font-semibold text-amber-900">.env 配置说明</h3>
        </div>
        <div className="font-mono text-xs text-amber-800 pl-8 space-y-1">
          <p>POSTGRES_PASSWORD=your-secure-db-password</p>
          <p>JWT_SECRET=your-random-64-char-string</p>
          <p>ENCRYPTION_KEY=your-32-byte-aes-key!!</p>
          <p>MAIL_DOMAIN=mail.yourdomain.com</p>
          <p>CORS_ORIGINS=https://mail.yourdomain.com</p>
        </div>
      </div>
    </div>
  </>
}
